@if (query.error()?.status !== 403) {
  <app-plugin-list #list [page]="query.page()" />
} @else {
  <div class="error-403" i18n>Access Denied</div>
}
